import React from 'react';
import { Link } from 'react-router-dom';

// Navigable card for the Home / Category grids.
// Props: to, title, description, icon (MUI), accent (CSS color), badge, disabled.
export default function HomeCard({ to, title, description, icon: Icon, accent, badge, disabled }) {
  const style = accent ? { '--card-accent': accent } : undefined;
  const content = (
    <>
      {badge ? <span className="home-card-badge">{badge}</span> : null}
      <span className="home-card-icon">{Icon ? <Icon /> : null}</span>
      <span className="home-card-title">{title}</span>
      {description ? <span className="home-card-desc">{description}</span> : null}
    </>
  );

  if (disabled) {
    return (
      <div className="home-card disabled" style={style}>
        {content}
      </div>
    );
  }
  return (
    <Link to={to} className="home-card" style={style}>
      {content}
    </Link>
  );
}
